import { useGetOne } from "react-admin";
import { AutovioCalendarEvent, isPracticalExam, isTheoryExam } from "../model/autovioCalendarEvents";
import { Student } from "../providers/studentsProvider";
import { getPracticalExamAttempt, getTheoryExamAttempt } from "../utils/examsAttempt";

export function useExamAttempt(event: AutovioCalendarEvent | undefined): number | undefined {
  const { data: student } = useGetOne<Student>(
    "students",
    { id: isPracticalExam(event) || isTheoryExam(event) ? event.student.uid : "" },
    { enabled: isPracticalExam(event) || isTheoryExam(event) },
  );
  if (student) {
    if (isPracticalExam(event)) {
      return getPracticalExamAttempt(event, student);
    } else if (isTheoryExam(event)) {
      return getTheoryExamAttempt(event, student);
    }
  }
  return undefined;
}
